
export enum PricingTypeCd {
	REGIONAL = 'Regional',
	STRATEGIC = 'Strategic'}

